import React, { useRef } from 'react'
import HeroBgAnimation from '../HeroBgAnimation'
import { HeroContainer, HeroBg, HeroLeftContainer, HeroRightContainer, HeroInnerContainer, TextLoop, Title, Span, SubTitle, ResumeButton } from './HeroStyle'
import HarshuImg from '../../images/Avichal.jpeg'
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';
import styled, { keyframes } from 'styled-components';

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
`;

const glowPulse = keyframes`
  0%, 100% { box-shadow: 0 0 30px rgba(133, 76, 230, 0.15), 0 0 60px rgba(133, 76, 230, 0.05); }
  50% { box-shadow: 0 0 50px rgba(133, 76, 230, 0.3), 0 0 100px rgba(133, 76, 230, 0.1); }
`;

const TiltImg = styled.img`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  max-width: 440px;
  max-height: 440px;
  border-radius: 50%;
  border: 3px solid ${({ theme }) => theme.primary};
  object-fit: cover;
  object-position: center 20%;
  background: ${({ theme }) => theme.bg};
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  will-change: transform;
  animation: ${float} 6s ease-in-out infinite, ${glowPulse} 4s ease-in-out infinite;

  @media (max-width: 1024px) {
    max-width: 380px;
    max-height: 380px;
  }
  @media (max-width: 768px) {
    max-width: 320px;
    max-height: 320px;
    animation: ${glowPulse} 4s ease-in-out infinite;
  }
  @media (max-width: 640px) {
    max-width: 260px;
    max-height: 260px;
  }
`;

const ProfileTilt = ({ src, alt }) => {
  const imgRef = useRef();

  const handleMouseMove = (e) => {
    if (window.innerWidth <= 768) return;
    const rect = imgRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateX = ((y - centerY) / centerY) * 10;
    const rotateY = ((x - centerX) / centerX) * 15;
    imgRef.current.style.transform = `perspective(600px) rotateX(${-rotateX}deg) rotateY(${rotateY}deg) scale(1.04)`;
  };

  const handleMouseLeave = () => {
    if (window.innerWidth <= 768) return;
    imgRef.current.style.transform = 'perspective(600px) rotateX(0deg) rotateY(0deg) scale(1)';
  };

  return (
    <TiltImg
      ref={imgRef}
      src={src}
      alt={alt}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      draggable={false}
    />
  );
};

const HeroSection = () => {
    return (
        <div id="about">
            <HeroContainer>
                <HeroBg>
                    <HeroBgAnimation />
                </HeroBg>
                <HeroInnerContainer>
                    <HeroLeftContainer id="Left">
                        <Title>Hi, I am <br /> {Bio.name}</Title>
                        <TextLoop>
                            I am a
                            <Span>
                                <Typewriter
                                    options={{
                                        strings: Bio.roles,
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </Span>
                        </TextLoop>
                        <SubTitle>{Bio.description}</SubTitle>
                        <ResumeButton href={Bio.resume} target='_blank' rel='noopener noreferrer'>Check Resume</ResumeButton>
                    </HeroLeftContainer>

                    <HeroRightContainer id="Right">
                        <ProfileTilt src={HarshuImg} alt="Harsh Avichal" />
                    </HeroRightContainer>
                </HeroInnerContainer>
            </HeroContainer>
        </div>
    )
}

export default HeroSection
